import { makeRequest } from './make-request.api'


export const loginRequest = (payload) => {
  return makeRequest('/authorization/login', {
    method: 'POST',
    body: payload
  })
}